module.exports = __webpack_public_path__ + "media/recenzie1.143eabbf.mp4";